import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ButtonNew as Button } from "components/buttonNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./kioskNotFound.scss";
import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons";

interface IKioskNotFoundProps {
  onBack: () => void;
}

export function KioskNotFound({ onBack }: IKioskNotFoundProps) {
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      onBack();
    }, 15000);

    return () => clearTimeout(timer);
  }, [onBack]);

  return (
    <div className="ui-kiosk-container">
      <div className="ui-kiosk-icon-error-container">
        <FontAwesomeIcon icon={faCircleExclamation} className="ui-kiosk-icon-error" />
      </div>

      <p className="ui-kiosk-title">{t("Booking not found")}</p>
      <p className="ui-kiosk-subtitle">{t("Please check the booking reference or scan your code again.")}</p>

      <div className="ui-kiosk-button-container ui-kiosk-error-buttons">
        <Button onClick={onBack} type="primary" className="ui-kiosk-button">
          {t("Try again")}
        </Button>
        <Button onClick={onBack} type="secondary" className="ui-kiosk-button ml-0">
          {t("Cancel")}
        </Button>
      </div>

      <p className="ui-kiosk-help">{t("Need help? Please see the Pro shop staff for assistance.")}</p>
    </div>
  );
}
